import {
  CheckCircleFilled,
  ClockCircleFilled,
  CloseCircleFilled,
} from '@ant-design/icons';

const STATUSTOKENS: Record<
  string,
  { classes: string; icon: React.ReactNode; fallbackLabel: string }
> = {
  ACCEPTED: {
    classes: 'text-emerald-700 bg-emerald-50',
    icon: <CheckCircleFilled />,
    fallbackLabel: 'Approved',
  },
  APPROVED: {
    classes: 'text-emerald-700 bg-emerald-50',
    icon: <CheckCircleFilled />,
    fallbackLabel: 'Approved',
  },
  PENDING: {
    classes: 'text-secondary-700 bg-secondary-50',
    icon: <ClockCircleFilled />,
    fallbackLabel: 'Pending',
  },
  REJECTED: {
    classes: 'text-rose-700 bg-rose-50',
    icon: <CloseCircleFilled />,
    fallbackLabel: 'Rejected',
  },
};

export default STATUSTOKENS;
